import React, { useState, useContext } from 'react';
import { Grid, Typography, TextField, FormControlLabel, Switch } from '@mui/material';
import { ThemeContext } from '../../../lib/contexts/ThemeContext';
import SubDomainField from './SubDomainField';

const MainOptions = ({ formData, handleChange, tempTheme }) => {
  const [newVals, setNewVals] = useState(formData);
  const [subdomain, setSubdomain] = useState(formData.subdomain || '');
  const {
    state: { finalTheme },
  } = useContext(ThemeContext);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const inputValue = type === 'checkbox' ? checked : value;

    if ((name === 'welcomeMessage' && value.length > 500) || (name === 'name' && value.length > 25)) {
      return;
    }

    handleChange(event);
    setNewVals((prevVals) => ({
      ...prevVals,
      [name]: inputValue,
    }));
  };

  return (
    <>
      <Typography
        variant="h6"
        sx={{ marginTop: 4 }}
      >
        Main Options
      </Typography>
      <Grid
        container
        spacing={3}
        alignItems="center"
      >
        <Grid
          item
          xs={12}
          sm={6}
        >
          <SubDomainField
            subdomain={subdomain}
            setSubdomain={setSubdomain}
            finalTheme={finalTheme}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          style={{ marginTop: '20px' }}
        >
          <TextField
            fullWidth
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            margin="normal"
            variant="outlined"
            inputProps={{ maxLength: 25 }}
            helperText={`${formData.name.length} / 25 characters`}
            sx={tempTheme}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <TextField
            fullWidth
            label="Welcome Message"
            name="welcomeMessage"
            value={formData.welcomeMessage}
            onChange={handleInputChange}
            multiline
            rows={3}
            style={{
              color: formData.welcomeMessage.length === 500 ? 'red' : 'black',
            }}
            InputProps={{
              style: {
                color: formData.welcomeMessage.length === 500 ? 'red' : 'black',
                backgroundColor:
                  formData.welcomeMessage.length === 500 ? 'rgba(255, 0, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)',
              },
            }}
            helperText={
              <span style={{ color: formData.welcomeMessage.length === 500 ? 'red' : 'black' }}>
                {`${formData.welcomeMessage.length} / 500 characters`}
              </span>
            }
            inputProps={{ maxLength: 500 }}
            sx={tempTheme}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
        >
          <TextField
            fullWidth
            label="Lead Email"
            name="leadEmail"
            type="email"
            value={formData.leadEmail}
            onChange={handleInputChange}
            placeholder="yourcompany@companyaddress.com"
            sx={tempTheme}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.receivePHI}
                name="receivePHI"
                onChange={handleInputChange}
              />
            }
            label="Receive PHI as part of API and webhook data"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default MainOptions;
